module.exports = __webpack_public_path__ + "icons/original/large/large-b5.746416be364e3c33aacd6055c476fbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-b5.png
// module id = YKaq
// module chunks = app